module.exports = __webpack_public_path__ + "static/Sebastian-Jimenez-7171b45bc99ee74a81840c1536b44284.png";